'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const FlagDkAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 29 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M2.83122e-06 8.88109e-06L28 0C28.0187 8.88109e-06 28.0187 8.88109e-06 28.0187 8.88109e-06V20H0H0.0186581L2.83122e-06 8.88109e-06Z",
          fill: "white"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M2.83122e-06 8.88109e-06L0.0186581 8H8.01866V0L2.83122e-06 8.88109e-06Z",
          fill: "#EF264D"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M12.0187 0V8H28.0187V8.88109e-06C28.0187 8.88109e-06 28.0187 8.88109e-06 28 0H12.0187Z",
          fill: "#EF264D"
        }
      ),
      /* @__PURE__ */ jsx("path", { d: "M28.0187 12H12.0187V20H28.0187V12Z", fill: "#EF264D" }),
      /* @__PURE__ */ jsx("path", { d: "M8.01866 20V12H0.0186581V20H0H8.01866Z", fill: "#EF264D" })
    ]
  }
);
const VpFlagDkAsset = forwardRef(FlagDkAsset);

export { VpFlagDkAsset as default };
